export default __webpack_public_path__ + "static/media/task.4e0d93ff.svg";